/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useCallback, useContext, useState } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import { DisplaySettingsWrapper } from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";

const AddressFieldItemEdit = () => {
    
    const { t } = useTranslation();
    const {
        type,
        name,
        index,
        value,
        settings,
        updateListItem,
        disabled = false
    } = useContext(ListItemContext);
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { styleOptions, placeholder } = schemaSettings || {};
    const ph = placeholder || t("commons.placeholderText");

    const [address, setAddress] = useState(value);
    const [itemLocalState, setItemLocalState] = useState({ value, settings });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 500),
        [updateListItem]
    );
    
    const onSettingsChange = (updateState) => {
        // TODO: SettingsStyleEdit prevents manage local UI state

        update(updateState, index);
        setItemLocalState(updateState);
    };
    
    const doAddressChange = (event) => {
        const newAddress = event.target.value;
        setAddress(newAddress);
        const newState = { ...itemLocalState, value: newAddress, settings };
        update(newState, index);
        setItemLocalState(newState);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onAddressChange = useCallback(
        debounce((event) => doAddressChange(event),500),
        [doAddressChange]
    );
    
    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-field-primary'>
                    {/*  Edit Address Value  */}
                    <TextField
                        className='simplicity-disabled'
                        fullWidth={true}
                        placeholder={ph}
                        defaultValue={address}
                        disabled={disabled}
                        variant='standard'
                        onChange={onAddressChange}
                    />
                </div>
                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={onSettingsChange}
                    />
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
export { AddressFieldItemEdit };
